// GENERATED by scripts/import-translations.js: one import per bundled
// language. Adding a language is a folder in the translations repo plus an
// import run; never hand-edit this file.
import de from './de.json';
import es from './es.json';

export const bundles = { de, es };
